import PropTypes from "prop-types";
import { DateFormat } from "@client.enums/dateTypes";
import { formatDate } from "@client.utils/dateUtils";

export const getDateFrom = (dateType) => {
  const from = new Date();
  if (dateType < 0) {
    from.setDate(from.getDate() + dateType);
  }
  return formatDate(from, DateFormat);
};

export const getDateTo = (dateType) => {
  const to = new Date();
  to.setHours(0, 0, 0, 0);

  if (dateType >= 0) {
    to.setDate(to.getDate() + dateType);
  }
  return formatDate(to, DateFormat);
};

export const filterPropTypes = PropTypes.shape({
  dateType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  meetingType: PropTypes.number.isRequired,
  team: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
}).isRequired;
